"use strict";
/**
 * Cabeceras de albarán de compra — el espejo del informe 1995. GH582.
 *
 * 🚨 **Las líneas no están aquí.** Viven en el espejo de compras (informe 18), que es el único
 * listado con el **factor de conversión**. Esto es lo que a aquéllas les falta: el número del
 * albarán, el folio que puso el proveedor y si la entrega ya está facturada.
 */
Object.defineProperty(exports, "__esModule", { value: true });
